<template>
    <div class="flex flex-col h-auto min-h-screen max-h-screen w-full bg-green-90">
        <div class="w-full px-5 md:px-10 lg:px-32 xl:px-64 pt-4 pb-3 bg-grey-600 text-green-300 text-3xl sm:text-4xl">
			<a @click="goBack" @keypress.enter="goBack" tabindex="0" class="cursor-pointer">
				<svg class="inline-block align-middle mr-1 -mt-1" width="30" height="30" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M19.375 23.25L11.625 15.5L19.375 7.75" class="stroke-current" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
				</svg>
			</a>
			
			Past Trips
		</div>
		<div>
			<div class="flex w-full">
				<a tabindex="0" @click="showMe" @keypress.enter="showMe" class="flex-grow cursor-pointer font-sans text-2xl text-center text-green-900 border-r-2 border-green-400 focus:outline-none" :class="{'border-b-2': page == 'friends'}">
					<span class="block text-center md:ml-10 lg:ml-32 xl:ml-64 py-3">MY TRIPS</span>
				</a>
				<a tabindex="0" @click="showFriends" @keypress.enter="showFriends" class="flex-grow cursor-pointer font-sans text-2xl text-center text-green-900 border-green-400 bg-green-200 focus:outline-none" :class="{'border-b-2': page == 'me'}">
					<span class="block text-center md:mr-10 lg:mr-32 xl:mr-64 py-3">FRIENDS</span>
				</a>
			</div>
			<div v-if="page == 'friends'" class="flex bg-green-200 border-green-400 border-b-2 px-5 md:px-10 lg:px-32 xl:px-64 py-3">
				<div class="flex-grow">
					<input tabindex="0" @keypress.enter="searchFriend" class="block w-full rounded-lg px-3 py-1 text-2xl bg-transparent border-4 border-solid border-green-800 text-green-1000 placeholder-green-700 font-sans" v-model="temp_search" placeholder="Enter a username..." />
				</div>
				<a tabindex="0" @click="searchFriend" @keypress.enter="searchFriend" class="block ml-3 px-2 py-2">
					<svg class="text-green-1000" width="28" height="28" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><circle cx="10" cy="10" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
				</a>
			</div>
		</div>
		<div class="flex-grow px-5 md:px-10 lg:px-32 xl:px-64 font-body text-green-1000 text-xl overflow-x-hidden overflow-y-auto">
			<div v-if="page == 'friends' && suggestions.length > 0 && trips.length == 0 && (error == '' || error == 'Enter a friend\'s username to see their trips')">
				<div v-for="(username, index) in suggestions">
					<a tabindex="0" @click="chooseSuggestion(username)" @keypress.enter="chooseSuggestion(username)" class="block font-sans text-2xl leading-none py-5 -mx-5 md:-mx-10 lg:-mx-32 xl:-mx-64 px-5 md:px-10 lg:px-32 xl:px-64 cursor-pointer">
						{{ username }}
					</a>

					<div class="block h-px w-page bg-green-600 -mx-5 md:-mx-10 lg:-mx-32 xl:-mx-64"></div>
				</div>

				<a tabindex="0" @click="clearSuggestions" @keypress.enter="clearSuggestions" class="block text-red-600 font-body text-2xl py-5">Clear history</a>
			</div>
			<div v-else-if="error != '' && (trips.length == 0 || search == '')" class="px-10 mx-auto" style="max-width: 450px;">
				<illustration />

				<p class="mt-6 mb-8 px-1 font-body text-green-800 text-2xl leading-none text-center">
					{{ error }}
				</p>
			</div>
			<div v-else-if="trips.length > 0 && search != ''" class="pt-5 mb-8 md:mb-12">
				<div v-for="(trip_data, index) in trips" v-bind:key="trip_data.id">
					<pasttripcard v-if="trip_data.type == 'trip'" :trip="trip_data"/>
					<advert v-if="trip_data.type == 'ad'" :data="trip_data" />
					<div v-if="false && index < trips.length - 1" class="block w-page bg-green-600 mb-5 -mx-5 md:-mx-10 lg:-mx-32 xl:-mx-64 pt-1"></div>
				</div>
			</div>
		</div>
		<div v-if="false" class="bg-red-500 w-full px-5 md:px-10 lg:px-32 xl:px-64 py-4">
			<h3 class="text-2xl sm:text-3xl text-white leading-none align-middle font-sans mb-1">Testing</h3>
            <h4 class="text-xl sm:text-2xl text-white leading-none align-middle font-body -mb-1">Lorem ipsum dolor emet.</h4>
		</div>

		<pasttripopup v-if="selected_trip != null" :trip="selected_trip" :error="selected_trip_error" />
    </div>
</template>

<script>
import Storages from 'js-storage';
import axios from 'axios';
import ErrorBox from '../components/ErrorBox.vue';
import PastTrip from '../components/PastTripCard.vue';
import PastTripPopup from '../components/PastTripPopup.vue';
import AdBanner from '../components/AdBanner.vue';
import TripsIllustration from '../components/TripsIllustration.vue';

export default {
    name: 'PastTrips',
    path: '/trips/:username?/:id?',
	components: {
		'error': ErrorBox,
		'pasttripcard': PastTrip,
		'pasttripopup': PastTripPopup,
		'advert': AdBanner,
		'illustration': TripsIllustration
	},
	props: ['username', 'id'],
	data() {
		return {
			error: 'Loading...',
			storage: null,
			trips: [],
			key: '',
			search: '',
			temp_search: '',
			page: 'me',
			suggestions: [],
			selected_trip: null,
			selected_trip_error: 'Loading...',
			user: {
				id: 0,
				username: '',
				email: '',
				premium: false
			}
		}
	},
    created() {
        this.storage = Storages.localStorage;

		if (!this.storage.isSet('session_key')) {
			this.key = "__NOT_AUTHENTICATED__";
		} else {
			this.getCurrentUser();
		}

		if (this.storage.isSet('friendsSuggestions')) {
			this.suggestions = this.storage.get('friendsSuggestions');
		}

		if (this.username == null || this.username == "me") {
			if (this.key == "__NOT_AUTHENTICATED__") {
				this.search = "me";
			} else {
				this.search = this.user.username;
			}
			this.getPastTrips();
		} else if (this.username == "friends") {
			this.showFriends();
		} else if (this.id != null && typeof this.id != "undefined") {
			var title = "See @" + this.username + "'s challenge attempts";
			var image = "https://lostinthecity.xyz/ogp/user/" + this.username + ".png";
			document.getElementById("meta-ogp-title").content = title;
			document.getElementById("meta-twitter-title").content = title;
			document.getElementById("meta-ogp-image").content = image;
			document.getElementById("meta-twitter-image").content = image;

			this.page = "friends";
			this.search = this.username;
			this.temp_search = this.username;

			this.getTrip();
		} else {
			this.showFriends();
			this.temp_search = this.username;

			var title = "See @" + this.username + "'s challenge attempts";
			var image = "https://lostinthecity.xyz/ogp/user/" + this.username + ".png";
			document.getElementById("meta-ogp-title").content = title;
			document.getElementById("meta-twitter-title").content = title;
			document.getElementById("meta-ogp-image").content = image;
			document.getElementById("meta-twitter-image").content = image;

			this.searchFriend();
			this.getPastTrips();
		}
    },
	methods: {
		toTitleCase(phrase) {
			return phrase
			.toLowerCase()
			.split(' ')
			.map(word => word.charAt(0).toUpperCase() + word.slice(1))
			.join(' ');
		},
		goBack() {
			this.$router.replace("/");
		},
		getCurrentUser() {
			this.key = this.storage.get('session_key');
			this.user = this.storage.get('authed_user');
		},
		showMe() {
			this.trips = [];
			this.page = "me";

			if (this.key == "__NOT_AUTHENTICATED__") {
				this.search = "me";
			} else {
				this.search = this.user.username;
			}

			this.error = "Loading...";
			this.getPastTrips();

			if (this.$router.history.current.path != '/trips/me') {
				this.$router.replace('/trips/me');
			}
		},
		showFriends(skip_history_replace) {
			this.trips = [];
			this.page = "friends";
			this.search = "";
			this.temp_search = "";
			this.error = "Enter a friend's username to see their trips";

			if (!skip_history_replace && this.$router.history.current.path != '/trips/friends') {
				this.$router.replace('/trips/friends');
			}
		},
		chooseSuggestion(username) {
			this.temp_search = username;
			this.searchFriend();
		},
		clearSuggestions() {
			this.suggestions = [];
			
			if (this.storage.isSet('friendsSuggestions')) {
				this.storage.remove('friendsSuggestions');
			}

			this.error = "Enter a friend's username to see their trips";
		},
		searchFriend() {
			if (this.temp_search == "") {
				this.error = "Enter a friend's username to see their trips";
				return;
			}

			this.trips = [];
			this.search = this.temp_search.toLowerCase();
			this.error = "Loading...";
			this.getPastTrips();

			var path = '/trips/' + this.search;
			if (this.id) path = path + '/' + this.id;

			if (this.$router.history.current.path != path) {
				this.$router.replace(path);
			}

			if (!this.suggestions.includes(this.search) && this.search != this.user.username) {
				this.suggestions.push(this.search);
				this.storage.set('friendsSuggestions', this.suggestions);
			}
		},
		getPastTrips() {
			var that = this;

			if (this.key == "__NOT_AUTHENTICATED__" && this.search == "me") {
				this.error = "You must be logged in to see your past trips";
				return;
			}

			axios.get('https://bakerstreet.arturs.co.uk/api/lostinthecity/trips?key=' + this.key + '&username=' + this.search)
			.then(function (response) {
				var data = response.data;

				if (data.success == true) {
					that.trips = data.response.trips;
					that.error = "";

					if (that.search == that.user.username) {
						that.page = "me";
					}
				} else {
					that.trips = [];
					that.error = data.response;
				}
			})
			.catch(function (error) {
				that.trips = [];
				if (error.response) {
					var data = error.response.data;
					that.error = data.response;
				} else {
					that.error = "An unknown error has occured.";
				}
			});
		},
		getTrip() {
			var that = this;

			axios.get('https://bakerstreet.arturs.co.uk/api/lostinthecity/trip?key=' + this.key + '&id=' + this.id)
			.then(function (response) {
				var data = response.data;

				if (data.success == true) {
					that.selected_trip = data.response.trip;
					that.selected_trip_error = "";

					if (that.username != that.selected_trip.username) {
						var path = "/trips/" + that.selected_trip.username + "/" + that.selected_trip.id;
						if (that.$router.history.current.path != path) {
							that.$router.replace(path);
						}
						that.search = that.selected_trip.username;
						that.temp_search = that.selected_trip.username;
					}

					that.getPastTrips();

					if (that.selected_trip.invalid == false
					&& that.selected_trip.incomplete == false
					&& that.selected_trip.under_review == false) {
						var title = "See @" + that.selected_trip.username + "'s challenge attempt";
						var description = "@" + that.selected_trip.username + " got " + that.selected_trip.points + " points on the Lost in the City challenge in " + that.toTitleCase(that.selected_trip.city.replace('_', ' ')) + "!";
						var image = "https://lostinthecity.xyz/ogp/trip/" + that.selected_trip.username + "-" + that.selected_trip.points + ".png";
						var snap_image = "https://lostinthecity.xyz/ogp/snap/" + that.selected_trip.username + "-" + that.selected_trip.points + ".png";
						document.getElementById("meta-ogp-title").content = title;
						document.getElementById("meta-twitter-title").content = title;
						document.getElementById("meta-ogp-description").content = description;
						document.getElementById("meta-twitter-description").content = description;
						document.getElementById("meta-ogp-image").content = image;
						document.getElementById("meta-twitter-image").content = image;
						document.getElementById("meta-snapchat-image").content = snap_image;
					}
				} else {
					that.selected_trip = {};
					that.selected_trip_error = data.response;
				}
			})
			.catch(function (error) {
				that.selected_trip = {};
				if (error.response) {
					var data = error.response.data;
					that.selected_trip_error = data.response;
				} else {
					that.selected_trip_error = "An unknown error has occured.";
				}
			});
		}
	}
}
</script>